import {Select, SelectContent, SelectItem, SelectTrigger} from '@components/ui/select'
import {CalendarIcon} from '@components/ui/icon'
import {useTranslation} from '@/translations/i18n.tsx'
import {z} from 'zod'
import {useParsedSearchParams} from '@hooks/useParsedSearchParams'

export const InsightsFilterParam = z.object({
    period: z.enum(['last_3_month', 'last_6_month']).catch('last_3_month')
})

export type InsightsFilterParam = z.infer<typeof InsightsFilterParam>

export const InsightsFiltersSelect = () => {
    const {t} = useTranslation()

    const insightsFilterOptions = [
        {
            label: t('insights:issues:last_month', {count: 3}),
            value: 'last_3_month'
        },
        {
            label: t('insights:issues:last_month', {count: 6}),
            value: 'last_6_month'
        }
    ]

    const {searchParams, setSearchParams} = useParsedSearchParams(InsightsFilterParam)

    return (
        <Select value={searchParams.period} onValueChange={value => value && setSearchParams({period: value})}>
            <SelectTrigger
                className="w-fit min-w-50 gap-2 px-4 py-2"
                icon={<CalendarIcon size={16} />}
                nativeButton={true}
            >
                {(value: string) => insightsFilterOptions.find(option => option.value === value)?.label}
            </SelectTrigger>
            <SelectContent className="z-3">
                {insightsFilterOptions.map(option => (
                    <SelectItem value={option.value} key={option.value}>
                        {option.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}
